module.exports = __webpack_public_path__ + "img/bg2.5c5a4078.png";